import moment from "moment/moment";


const SelfiesModal = ({ show, onClose, selfies }) => {
  if (!show) return null;
  return (
    <div
      className="modal fade show"
      style={{
        display: "block",
        backgroundColor: "rgba(0,0,0,0.5)",
      }}
    >
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content">
          {/* Header */}

          <div className="modal-header p-4">
            <div>
              <h6 className="fw-bold">Agents Selfies</h6>
            </div>

            <button className="btn-close-route btn-sm" onClick={onClose}>
              <i aria-hidden="true" className="ki ki-close text-dark font-size-xs"></i>
            </button>
          </div>

          {/* Summary */}
          <div className="modal-body p-4">


            <div className="row mb-3">
                 {selfies?.length > 0 ? (
                selfies?.map((item, index) => (
                  <div className="col-md-2 mb-3" key={index}>
                      <img
                        src={item?.selfieUrl}
                        alt={`Selfie ${index + 1}`}
                        className="object-fit-cover w-100"
                      />
                    
                        <p className="mt-2 text-center font-weight-bold">
                          {item?.capturedAt ? moment.utc(item?.capturedAt).local().format("DD MMM YYYY, hh:mm A") : "No timestamp available"}
                        </p>
                
                
                  </div>
                ))
              ) : (
                <p className="mt-2 text-center font-weight-bold w-100">No selfies available</p>
              )}
            </div>

          </div>

          {/* <div className="modal-footer">
            <button className="btn btn-secondary" onClick={onClose}>
              Close
            </button>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default SelfiesModal;
